import StickySubNav from "./components/StickyThemeNavigation";
import StickySubNavMobile from "./components/StickyMobileThemeNavigation";

const stickySubNav = new StickySubNav();
const stickySubNavMobile = new StickySubNavMobile();

window.addEventListener( "DOMContentLoaded", () => {
  // Initialize sticky navigation for both mobile and desktop.
  stickySubNavMobile.initialize();
  stickySubNav.initialize();

  // Setup event listeners and keyboard events.
  stickySubNavMobile.setupEventListeners();
  stickySubNav.keyboardEvents();

  // Methods.
  stickySubNavMobile.events();
  stickySubNavMobile.showSubNav();
} );

window.addEventListener( "dh:resize", () => stickySubNav.resize() );
document.addEventListener( 'scroll', () => stickySubNav.detectIfSubNavStuck() );
